"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const beige = '#eccaaf';
const black = '#222222';
const blue = '#61c8d7';
const purple = '#7070ff';
const green = '#7aefb2';
const red = '#fb7578';
const pink = red;
const orange = '#ffbf86';
const yellow = '#ffef86';
const subtleWhite = '#fafafa';
const pureBlack = '#000000';
const utilityGrey = '#E2EEF0';
const colors = {
  beiges: {
    2: '',
    5: '#f4f2f2',
    50: '#eccaaf'
  },
  blacks: {
    // background shades
    5: '#fbfbfc',
    // NOTE: adelya would like to update this to: #F4F5F6 so it's slightly darker/better contrast in the editors
    10: '#f5f5f5',
    15: '#e5e5e5',
    20: '#d6d6d6',
    30: '#adadad',
    40: '#7a7a7a',
    50: '#525252',
    60: '#3d3d3d',
    65: '#2d2d2d',
    // matches the code theme background
    70: black,
    71: '#393E42',
    // TODO: This is 70 in the new world
    75: '#272727',
    // matches the code gutter background
    80: '#1D1F21',
    100: '#000000' // matches the code gutter background
  },
  blues: {
    5: '#F4F6F9',
    10: '#def3f7',
    20: '#ade1eb',
    21: '#B0E4EB',
    30: blue,
    31: '#61C9D7',
    40: '#0298bf',
    41: '#05AAC0',
    // New 40
    50: '#0182a2',
    60: '#016179',
    85: '#3E3E57' // default pdf fill output color
  },
  purples: {
    10: '#d6d6ff',
    20: '#adadff',
    30: purple,
    40: '#5c5cff',
    50: '#4747ff',
    60: '#0000cc'
  },
  greens: {
    5: '#dafbeb80',
    10: '#dafbeb',
    20: '#b6f6d5',
    30: '#7aefb2',
    35: '#5ceba0',
    // TODO: this is 30 in the new world
    40: '#4ceb98',
    50: '#23e781',
    60: '#16ca6d',
    70: '#acc99e'
  },
  pinks: {
    10: '#fed7d8',
    20: '#fdb0b1',
    30: red,
    40: '#fa6163',
    50: '#f9393c',
    60: '#c60609'
  },
  reds: {
    10: '#fed7d8',
    20: '#fdb0b1',
    30: red,
    35: '#ec7068',
    // sort of an outlier, but in the design...
    40: '#fa6163',
    50: '#f9393c',
    60: '#c60609',
    85: '#A00000' // PDF filling red
  },
  yellows: {
    10: '#fff9d6',
    20: '#fff4ad',
    30: '#ffef86',
    40: '#ffe95c',
    50: '#ffde0a',
    60: '#e0c200',
    70: '#c3a902'
  },
  oranges: {
    10: '#ffe9d6',
    20: '#ffd3ad',
    30: orange,
    40: '#ffa85c',
    50: '#ff871f',
    60: '#e06900'
  },
  beige,
  black,
  blue,
  purple,
  green,
  pink,
  red,
  orange,
  yellow,
  subtleWhite,
  pureBlack
};
colors.utilityGrey = utilityGrey;
colors.textColor = colors.black;
colors.inputBorderColor = '#E2EEF0'; // TODO: update this to a new color, looks good like this for now tho.
colors.inputBorderColorActive = black;
colors.borderWidth = 2;
colors.circleButton = {
  background: '#d2e8ec',
  backgroundHover: '#b2dfe6',
  backgroundDisabled: colors.blacks[15],
  color: 'white',
  colorHover: 'white',
  colorDisabled: colors.blacks[20],
  messageColor: '#b0ccd0',
  messageColorHover: '#91cad4',
  cta: {
    background: green,
    backgroundHover: colors.greens[40],
    backgroundDisabled: colors.blacks[20],
    color: black,
    colorHover: black,
    colorDisabled: colors.blacks[10]
  },
  toolbar: {
    color: colors.black,
    colorHover: colors.black,
    colorDisabled: colors.blacks[30]
  }
};
colors.radioButton = {
  color: colors.black,
  colorHover: 'white',
  background: 'white',
  backgroundHover: colors.blacks[40],
  border: '#d2e8ec',
  borderHover: colors.blacks[40]
};
const textColors = {
  blue,
  green: colors.greens[60],
  pink,
  red: colors.reds[40],
  orange: colors.oranges[40],
  yellow: colors.yellows[70],
  subtle: colors.blacks[30],
  subtleBlue: '#BBBFC5',
  link: colors.blues[40],
  linkHover: colors.blues[50]
};
colors.pdfFill = {
  black: colors.black,
  grey: textColors.subtle,
  white: '#FFFFFF',
  darkBlue: colors.blues[85],
  blue,
  purple,
  green: textColors.green,
  yellow: colors.yellows[60],
  orange: textColors.orange,
  red: colors.reds[85]
};
colors.workflows = {
  navIconBackground: colors.green,
  navIconForeground: colors.blacks[100]
};
colors.eSign = {
  navIconBackground: colors.yellow,
  navIconForeground: colors.blacks[100]
};
colors.pdfTemplates = {
  navIconBackground: colors.blue,
  navIconForeground: colors.blacks[100]
};
const paddings = {
  5: 5,
  10: 10,
  15: 15,
  20: 20,
  30: 30,
  40: 40,
  60: 60,
  80: 80,
  90: 90,
  100: 100
};
const fontSizes = {
  20: 10,
  30: 12,
  40: 14,
  50: 16,
  60: 18,
  70: 20,
  80: 22,
  90: 24,
  100: 36
};
const fontWeights = {
  light: 300,
  normal: 400,
  semiBold: 500,
  bold: 700
};
const fontStack = 'Barlow, -apple-system, BlinkMacSystemFont, Helvetica, Arial, sans-serif';
const fontFamilies = {
  body: fontStack,
  heading: fontStack,
  monospace: 'Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace'
};
const shadows = {
  30: '0 0 6px 0 rgba(0,0,0,0.05)',
  50: '0 2px 11px 0 rgba(0,0,0,0.06)',
  55: '0 1px 11px 0 rgba(0,0,0,0.08)',
  60: '0 2px 15px 0 rgba(0,0,0,0.08)'
};
const sizes = {
  appTopPadding: 30,
  appTitleHeight: 30,
  customLogoHeight: 30
};
const selectors = {
  dashboardScrollContainer: '#app-container',
  // This is specifically only used when `Affix`ing the Etch Free
  // CastConnectEditor component.
  unauthenticatedContainer: 'body'
};
const globalStyleTheme = {
  pink,
  'input-border-width': '2px',
  'font-family-body': fontStack,
  'text-color': black,
  'font-weight-normal': fontWeights.normal,
  'component-padding': paddings[20],
  'text-color-heading': pureBlack,
  'input-border-color': colors.inputBorderColor,
  'font-weight-bold': fontWeights.bold,
  'link-color': textColors.link,
  'link-color-hover': textColors.linkHover
};
var _default = exports.default = {
  colors,
  textColor: colors.textColor,
  textColors,
  paddings,
  padding: paddings[20],
  fontSizes,
  fontWeights,
  fontFamilies,
  shadows,
  sizes,
  selectors,
  borderRadius: 2,
  borderWidth: 2,
  globalStyleTheme
};